import React from 'react';
import { WatchFullInfoControlPanel } from './components/WatchFullInfoControlPanel';
import { Info } from './components/Info';
import { Controls } from './components/Controls';
import { ModalWindows } from './components/ModalWindows';
import style from './WatchFullInfoView.module.scss';

export const WatchFullInfoView: React.FC = () => {
	return (
		<div data-test="WatchFullInfoView">
			<WatchFullInfoControlPanel />
			<div className={style.content}>
				<Info />
				<Controls />
				<ModalWindows />
			</div>
		</div>
	);
};
